<template>
  <b-card class="order-summary-confirmation" header-tag="header" title-tag="h5">
    <div slot="header" class="header">
      <div class="placeholder" />
      <h3>order summary</h3>
      <div class="arrow" :class="{ collapsed: collapsed }" @click="collapse">
        <carat-svg />
      </div>
    </div>
    <div
      class="order-items-container"
      v-for="(item, index) in orderItems"
      :key="index"
    >
      <order-item-summary
        :meal-name="item.name"
        :menu-data="menuData"
        v-bind:item="item"
        :dense="collapsed"
      />
      <div class="separator item" v-show="index < orderItems.length - 1" />
    </div>
    <div class="accessories" v-show="!collapsed">
      <div class="separator item" />
      <h5>Serving Accessories</h5>
      <div class="content">
        Enough bowls, forks, and napkins for everyone, plus serving spoons and
        tongs.
      </div>
      <h5 class="text-center not-included">Setup not included</h5>
    </div>
    <div class="separator" />
    <div class="price-group subtotal">
      <h5>BAG TOTAL</h5>
      <h5>{{ orderTotal | toCurrency }}</h5>
    </div>
    <div v-if="submittedOrderHasPromotion" class="price-group">
      <h5 class="text-secondary text-uppercase">
        {{ submittedOrderPromotionName }}
      </h5>
      <h5 class="text-secondary text-uppercase">
        {{ (submittedOrderPromotionDeduction * -1) | toCurrency }}
      </h5>
    </div>
    <div class="price-group subtotal">
      <h5>SUBTOTAL</h5>
      <h5>{{ subTotal | toCurrency }}</h5>
    </div>
    <div v-if="isDelivery" class="price-group delivery-fee-tax">
      <h6>DELIVERY FEE</h6>
      <h6>{{ deliveryFee | toCurrency }}</h6>
    </div>
    <div class="price-group" :class="!isDelivery ? 'tax-spacer' : ''">
      <h6>TAX</h6>
      <h6>{{ tax | toCurrency }}</h6>
    </div>
    <div v-if="isDelivery && deliveryTax" class="price-group delivery-fee-tax">
      <h6>DELIVERY TAX</h6>
      <h6>{{ deliveryTax | toCurrency }}</h6>
    </div>
    <div class="price-group tip-spacer" v-if="isDelivery">
      <h6>TIP</h6>
      <h6>{{ deliveryTip | toCurrency }}</h6>
    </div>
    <div class="price-group">
      <h5>TOTAL</h5>
      <h5>{{ total | toCurrency }}</h5>
    </div>
  </b-card>
</template>

<script>
import { mapGetters } from 'vuex'
import caratSvg from '@/components/common/CaratSvg'
import OrderItemSummary from '@/components/confirmation/OrderItemSummary'
export default {
  props: {
    total: Number,
    orderTotal: Number,
    tax: Number,
    deliveryFee: Number,
    deliveryTax: Number,
    orderItems: Array,
    restaurantMenuData: Array,
    isDelivery: Boolean,
    deliveryTip: Number,
  },
  computed: {
    ...mapGetters([
      'submittedOrderHasPromotion',
      'submittedOrderPromotionName',
      'submittedOrderPromotionDeduction',
    ]),
    menuData() {
      // use the prop input as the override to the default store restaurant menu
      return this.restaurantMenuData || this.$store.getters.restaurantMenuData
    },
    subTotal() {
      return this.orderTotal - this.submittedOrderPromotionDeduction
    },
  },
  data: () => ({
    collapsed: false,
  }),
  components: {
    caratSvg,
    OrderItemSummary,
  },
  methods: {
    collapse() {
      this.collapsed = !this.collapsed
    },
  },
}
</script>

<style lang="scss">
.order-summary-confirmation {
  .arrow {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 1px;
    cursor: pointer;
    color: $catering-gold;
    transform: rotate(180deg);
    path {
      stroke: $catering-gold;
    }
    &.collapsed {
      transform: rotate(0);
    }
  }
  .card-header {
    background-color: white;
  }
  .header {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  header {
    // TODO make it global for bootstrap cards
    box-shadow: 0px 3px 20px 0px rgba(0, 0, 0, 0.15);
  }
  h3 {
    margin: 0;
    text-transform: uppercase;
  }
  .price-group {
    display: flex;
    justify-content: space-between;
  }
  h5 {
    font-size: 18px;
  }
  h6 {
    font-size: 16px;
  }
  .delivery-fee-tax > h6 {
    color: $catering-red;
  }
  .tax-spacer {
    margin-bottom: 15px;
  }
  .tip-spacer {
    margin-bottom: 15px;
  }
  .separator {
    border-bottom: 1px solid $catering-light-gray;
    opacity: 0.3;
    margin: 15px -1.25rem; // to match bootstrap card's padding
    &.item {
      margin: 15px 0;
    }
  }
  .accessories {
    line-height: 1.2;
    h5 {
      text-transform: uppercase;
      font-weight: bold;
    }
    .content {
      color: $catering-light-grey-brown;
      margin-bottom: 10px;
      font-size: 13px;
    }
    .not-included {
      padding-top: 18px;
      font-size: 16px;
    }
  }
}
@include media-breakpoint-up(md) {
  .order-summary-confirmation {
    .card-body {
      margin-left: 70px;
      margin-right: 70px;
    }
    .separator {
      margin-left: calc(-1.25rem - 70px);
      margin-right: calc(-1.25rem - 70px);
      &.item {
        margin-left: calc(-1.25rem - 20px);
        margin-right: calc(-1.25rem - 20px);
      }
    }
  }
}
</style>
